
import { useLocation } from 'react-router-dom';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userDataConnect } from "../../data_connect/userDataConnect";
import { useAuthContextValueHook } from "../../contexts/AuthContext";

export default function UserPermissionComponent(props) {
    const location = useLocation();
    const authContextValueHook = useAuthContextValueHook();
    const reduxDispatch = useDispatch();

    useEffect(() => {
        async function userFetchInit() {
            if (!location || !authContextValueHook.isReady) {
                return;
            }

            if (!authContextValueHook.isLoggedIn) {
                reduxDispatch({
                    type: "USER_REDUX_CLEAR_USER_INFO",
                });
                return;
            }

            await handleFetchUserInfo();
        }

        userFetchInit();
    }, [
        location.pathname,
        authContextValueHook.isReady,
        authContextValueHook.isLoggedIn,
    ]);

    const handleFetchUserInfo = async () => {
        await userDataConnect()
            .getInfoOwn()
            .then((res) => {
                if (res?.status === 200 && res?.data?.message === "success") {
                    reduxDispatch({
                        type: "USER_REDUX_SET_DATA",
                        payload: {
                            isLoading: false,
                            userInfo: res.data.data,
                        },
                    });
                }
            })
            .catch((err) => {
                console.log(err, err.response);
                reduxDispatch({
                    type: "USER_REDUX_CLEAR_USER_INFO",
                });
            });
    };
    return null;
}
